import { Reducer } from 'redux';

import { MatchDetailsStateExt } from '@om-fe/core/components/match-details/match-details.store';
import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction } from '@om-fe/store';
import { UpdateAction, UpdateActionPayload } from '@om-fe/api';
import find from 'lodash/find';
import { AggregatorStreamingProviderEvent, MatchDetailsViewModel, MatchModel, ModelTypes } from '@om-fe/models';
import { convertMatch } from '@om-fe/core/core/converters/event';
import { AppDispatch, AppThunk } from '@om-fe/core/core/types';
import {
    apiSubscribeAction,
    apiUnsubscribeAction,
    attachReducerAction,
    detachReducerAction
} from '@om-fe/core/utils/action';

export const SLICE_LIVE_MATCH_DETAILS: string = 'live-match-details';
const TOPIC_MATCH_DETAILS: string = 'match/:matchId';

const defaultLiveMatchDetailsState: MatchDetailsStateExt = {
    ready: false,
    event: null,
}

enum LiveMatchDetailsActions {
    Clear = 'LIVE_MATCH_DETAILS:CLEAR',
}

const clearLiveMatchDetails = (): AppAction => ({
    type: LiveMatchDetailsActions.Clear,
})

function aggregatorHasStreamingAvailable(payload: UpdateActionPayload<any>): boolean {
    const { records } = payload;

    return !!find(records, { _type: ModelTypes.STREAMING_PROVIDER_EVENT_RELATION });
}

function reprocessState(
    state: MatchDetailsStateExt,
    action: UpdateAction<MatchModel | AggregatorStreamingProviderEvent, number>,
): MatchDetailsStateExt {

    const { payload } = action;

    if (!payload.records || !payload.records.length) {
        return {
            ...state,
            ready: true,
        };
    }
    const event: MatchDetailsViewModel = convertMatch(payload.records[0] as MatchModel);

    return {
        ...state,
        event,
        hasStreamingAvailable: aggregatorHasStreamingAvailable(payload),
        ready: true,
    };
}

export function createReducer(): Reducer {
    return (state: MatchDetailsStateExt = defaultLiveMatchDetailsState, action: AppAction): MatchDetailsStateExt => {
        const { type, meta } = action;

        if (meta && meta.slice === SLICE_LIVE_MATCH_DETAILS) {
            if (meta.target === TOPIC_MATCH_DETAILS) {
                switch (type) {
                    case ACTION_CORE_API_SUB_DUMP:
                    case ACTION_CORE_API_SUB_UPDATE: {
                        return reprocessState(state, action as UpdateAction<MatchModel, number>);
                    }
                }
            }

        } else {
            switch (type) {
                case LiveMatchDetailsActions.Clear: {
                    return defaultLiveMatchDetailsState;
                }
            }
        }

        return state;
    };
}

export const subscribeToLiveMatchDetails = (matchId: string): AppThunk => (dispatch: AppDispatch) => {
    const liveMatchDetailsReducer: Reducer = createReducer();
    dispatch(attachReducerAction(SLICE_LIVE_MATCH_DETAILS, liveMatchDetailsReducer));
    dispatch(apiSubscribeAction(TOPIC_MATCH_DETAILS, { matchId }, SLICE_LIVE_MATCH_DETAILS));
}

export const unsubscribeLiveMatchDetails = (matchId: string): AppThunk => (dispatch: AppDispatch) => {
    dispatch(clearLiveMatchDetails());
    dispatch(detachReducerAction(SLICE_LIVE_MATCH_DETAILS));
    dispatch(apiUnsubscribeAction(TOPIC_MATCH_DETAILS, { matchId }, SLICE_LIVE_MATCH_DETAILS));
}

